import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

flatpickr.localize(Portuguese)

export default class extends Controller {
  static values = {
    defaultDate: String
  }
  
  connect() {
    flatpickr(this.element, {
      altInput: true,
      altFormat: "d/m/Y",
      dateFormat: "Y-m-d",
      defaultDate: this.defaultDateValue || undefined,
      allowInput: true
    })
  }

  open() {
    this.picker?.open()
  }
}
